import type {
  IAccountEditDTO,
  IInvestorAnalysisData,
} from '@types'

import type { IStock } from '~/@types/assets'
import UserApi from '@api/UserApi'

export default abstract class UserAdapter {
  public static async getAssetsWatching(): Promise<Array<IStock>> {
    return UserApi.getAssetsWatching()
  }

  public static async updateUser(data: IAccountEditDTO): Promise<boolean> {
    const response = await UserApi.updateUser(data)
    return response.success
  }

  public static async updateUserInvestorData(data: IInvestorAnalysisData): Promise<boolean> {
    const response = await UserApi.updateUserInvestorData(data)
    return response.success
  }

  public static async uploadUserAvatar(data: FormData): Promise<boolean> {
    const response = await UserApi.updateAvatar(data)
    return response.success
  }
}
